import { RRule } from 'rrule';

export const getRruleInterval = (rrule: string) => {
  return RRule.fromString(rrule).options.interval || 1;
};
